import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ServiceListItem = ({ service }) => {
    const [hover, setHover] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
    const [isExpanded, setIsExpanded] = useState(false);

    // Detect small screens dynamically
    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleMouseEnter = () => setHover(true);
    const handleMouseLeave = () => setHover(false);

    const listItemStyle = {
        ...styles.listItem,
        boxShadow: hover
            ? '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
            : 'none',
        borderColor: hover ? '#198b44' : '#e5e7eb',
        position: 'relative',
    };

    // Shorten description for small screens
    const fullDescription = service.description || 'No description.';
    const shortDescription =
        fullDescription.length > 100
            ? fullDescription.substring(0, 100) + '...'
            : fullDescription;

    const displayDescription =
        isSmallScreen && !isExpanded ? shortDescription : fullDescription;

    return (
        <li
            style={listItemStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div style={styles.container}>
                <div style={styles.contentContainer}>
                    <div style={styles.header}>
                        <div style={{ paddingRight: !isSmallScreen ? '180px' : '0' }}>
                            <h4 style={styles.title}>{service.name}</h4>
                            <p style={styles.provider}>
                                {service.mda?.fullName || service.mda?.shortName || 'N/A'}
                            </p>
                        </div>

                        {/* Hide top-right button on small screens */}
                        {!isSmallScreen && (
                            <div style={styles.actions}>
                                <Link to={`/service/${service.id}`}>
                                    <button style={styles.button}>View Details & Apply</button>
                                </Link>
                            </div>
                        )}
                    </div>

                    <p style={styles.description}>{displayDescription}</p>

                    {/* ✅ Read more toggle on small screens */}
                    {isSmallScreen && fullDescription.length > 100 && (
                        <button
                            style={styles.readMoreBtn}
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? 'Read less' : 'Read more'}
                        </button>
                    )}

                    {/* ✅ Button bottom-right on small screens */}
                    {isSmallScreen && (
                        <div style={styles.bottomButtonContainer}>
                            <Link to={`/service/${service.id}`}>
                                <button style={styles.button}>View Details & Apply</button>
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </li>
    );
};

const styles = {
    listItem: {
        border: '1px solid #e5e7eb',
        borderRadius: '0.5rem',
        padding: '1.5rem',
        marginBottom: '1rem',
        backgroundColor: '#ffffff',
        transition: 'all 0.2s',
        // position: 'relative' is applied in the component logic above
    },
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '1rem',
        flexDirection: 'column',
    },
    contentContainer: {
        flex: 1,
        position: 'relative',
        width: '100%', 
    },
    header: {
        // Removed flex properties that were causing the misalignment
        // The button is now positioned independently of the header flow
        position: 'relative',
    },
    title: {
        marginBottom: '0.25rem',
        color: '#1f2937',
        marginTop: 0, // Ensure no top margin pushes text down
    },
    provider: {
        color: '#6b7280',
        fontSize: '0.875rem',
        margin: 0,
    },
    actions: {
        // UPDATED: Absolute positioning ensures it is ALWAYS in the corner
        position: 'absolute',
        top: 0,
        right: 0,
    },
    button: {
        padding: '0.5rem 1rem',
        backgroundColor: '#198b44',
        color: 'white',
        border: 'none',
        borderRadius: '0.375rem',
        cursor: 'pointer',
        fontSize: '0.9rem',
        whiteSpace: 'nowrap', // Ensures button text doesn't wrap
    },
    description: {
        marginTop: '1rem',
        color: '#4b5563',
        fontSize: '0.95rem',
    },
    readMoreBtn: {
        background: 'none',
        border: 'none',
        color: '#198b44',
        fontWeight: '600',
        marginTop: '0.25rem',
        cursor: 'pointer',
    },
    bottomButtonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '1rem',
    },
};

export default ServiceListItem;